import { render, staticRenderFns } from "./articleUpdate.vue?vue&type=template&id=6aa5cf60&"
import script from "./articleUpdate.vue?vue&type=script&lang=js&"
export * from "./articleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./articleUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports